import { render, staticRenderFns } from "./TextQuestion.vue?vue&type=template&id=153a05e6&"
import script from "./TextQuestion.vue?vue&type=script&lang=ts&"
export * from "./TextQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports